import React from 'react';
import PropTypes from 'prop-types';

export default function MPartnerCard({ name, img, href }) {
	return (
		<a href={href}>
			<figure className="m-partner-card">
				<img src={img} alt={name} />
			</figure>
		</a>
	);
}

MPartnerCard.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.partner-card.js